module.exports = __webpack_public_path__ + "img/interface_news.37a83de7.png";